webpackJsonp([74],{

/***/ "GnEM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/title-block_0943c583757a6eb44ac3542962443093.html";

/***/ }),

/***/ "dhyF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TitleBlock = (function () {
    TitleBlock.$inject = ["$sce", "TranslateSvc", "$scope", "$element", "$compile"];
    function TitleBlock($sce, TranslateSvc, $scope, $element, $compile) {
        var _this = this;
        this.$sce = $sce;
        this.TranslateSvc = TranslateSvc;
        this.$scope = $scope;
        this.$element = $element;
        this.$compile = $compile;
        this.getHtml = function (html) {
            return _this.$sce.trustAsHtml(html);
        };
        this.translate = function (str) {
            return _this.TranslateSvc.has(str) ? _this.TranslateSvc.get(str) : str;
        };
        this.level = this.level || 2;
        var mapText = _.compose(this.getHtml, this.translate);
        this.tbTitle = mapText(this.tbTitle);
        this.description = mapText(this.description);
        this.appendH1();
    }
    TitleBlock.prototype.appendH1 = function () {
        var h1 = angular.element("<h" + this.level + " ng-bind-html=\"$ctrl.tbTitle\" class=\"title-block-title\"></h>");
        var container = this.$element[0].querySelector('.title-block');
        var compiledH1 = this.$compile(h1)(this.$scope);
        angular.element(container).prepend(compiledH1);
    };
    return TitleBlock;
}());
angular.module('animatronApp.titleBlock', []).component('titleBlock', {
    bindings: {
        level: '<',
        tbTitle: '<',
        description: '<',
        color: '@',
        size: '@'
    },
    controller: TitleBlock,
    templateUrl: __webpack_require__("GnEM")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/74-257c10c0995a4d25fa59.min.js